import React from "react";
import { UpgradeMembershipModalProps } from "../../UpgradeMembershipModal";
import { ProductHeading } from "../ProductHeading";
import styles from "./UpgradeComplete.module.scss";

export type UpgradeCompleteProps = {
  subTitle?: string;
};

const UpgradeComplete = ({ subTitle }: UpgradeCompleteProps) => (
  <>
    <ProductHeading className={styles.heading} subTitle={subTitle} />
  </>
);

export default UpgradeComplete;
